namespace TabAurous.JobWork {
    export namespace JobWorkOrderService {
        export const baseUrl = 'JobWork/JobWorkOrder';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<JobWorkItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "JobWork/JobWorkOrder/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JobWorkOrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
